import ProjectsPage from './project/list-projects';
import LoginPage from '../login';
import { useAuthState } from '../../../hooks/auth';

const HomePage = () => {
  const authState = useAuthState();

  return (
    <div className="home">
      {
        authState.loggedIn.get()
          ? <ProjectsPage />
          : <LoginPage />
      }
    </div>
  )
};

export default HomePage;
